import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { loadingTrue, loadingFalse } from "../../../Reducer/loaderSlice";
import Handler from "../../../Helpers/Handler";
import "../../../Assets/css/style.css";
import MainLayout from "../../../Partials/MainLayout";
import FeedLayout from "../../../Partials/FeedLayout";

const CreateEvent = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [form, setForm] = useState({
        title: "",
        description: "",
        event_date: "",
    });

    const [errors, setErrors] = useState({});

    const validate = () => {
        const errs = {};
        if (!form.title.trim()) errs.title = "Title is required";
        else if (form.title.trim().length < 3) errs.title = "Title must be at least 3 characters";
        else if (form.title.trim().length > 255) errs.title = "Title too long";
        if (!form.event_date) errs.event_date = "Event date is required";
        else if (form.event_date < new Date().toISOString().split("T")[0])
            errs.event_date = "Date cannot be in the past";
        return errs;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((f) => ({ ...f, [name]: value }));
        setErrors((err) => ({ ...err, [name]: "" }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errs = validate();
        if (Object.keys(errs).length) return setErrors(errs);

        dispatch(loadingTrue());
        const res = await Handler({
            method: "POST",
            url: "/events/create.php",
            data: form,
        });
        dispatch(loadingFalse());

        if (res.success) {
            toast.success("Event created successfully!");
            navigate("/user/events");
        } else {
            toast.error(res.message || "Failed to create event");
        }
    };

    return (
        <MainLayout>
            <FeedLayout>
                <div className="ev-page">
                    <div className="ev-header">
                        <div>
                            
                            <h1 className="ev-title mt-2">Create Event</h1>
                            <p className="ev-subtitle">Fill in the details to schedule a new event</p>
                        </div>
                    </div>

                    <div className="ev-form-wrap">
                        <form className="ev-form" onSubmit={handleSubmit}>

                            {/* Progress bar visual */}
                            <div className="ev-form-steps">
                                <div className="ev-step active">
                                    <div className="ev-step-dot"><i className="bx bx-info-circle" /></div>
                                    <span>Details</span>
                                </div>
                                <div className="ev-step-line" />
                                <div className="ev-step">
                                    <div className="ev-step-dot"><i className="bx bx-link" /></div>
                                    <span>Community</span>
                                </div>
                                <div className="ev-step-line" />
                                <div className="ev-step">
                                    <div className="ev-step-dot"><i className="bx bx-user-plus" /></div>
                                    <span>Vendors</span>
                                </div>
                            </div>

                            <div className="ev-form-section">
                                <label className="ev-label">
                                    Event Title <span className="ev-required">*</span>
                                </label>
                                <input
                                    className={`ev-input ${errors.title ? "ev-input-error" : ""}`}
                                    name="title"
                                    value={form.title}
                                    onChange={handleChange}
                                    placeholder="e.g. Annual Business Summit 2025"
                                />
                                {errors.title && <span className="ev-error-msg"><i className="bx bx-error-circle" /> {errors.title}</span>}
                            </div>

                            <div className="ev-form-section">
                                <label className="ev-label">Description</label>
                                <textarea
                                    className="ev-textarea"
                                    name="description"
                                    value={form.description}
                                    onChange={handleChange}
                                    placeholder="Describe the event objectives, agenda, or any other relevant details..."
                                    rows={4}
                                />
                            </div>

                            <div className="ev-form-section">
                                <label className="ev-label">
                                    Event Date <span className="ev-required">*</span>
                                </label>
                                <input
                                    type="date"
                                    className={`ev-input ${errors.event_date ? "ev-input-error" : ""}`}
                                    name="event_date"
                                    value={form.event_date}
                                    onChange={handleChange}
                                    min={new Date().toISOString().split("T")[0]}
                                />
                                {errors.event_date && <span className="ev-error-msg"><i className="bx bx-error-circle" /> {errors.event_date}</span>}
                            </div>

                            <div className="ev-form-actions">
                                <button type="button" className="ev-btn-secondary" onClick={() => navigate("/user/events")}>
                                    Cancel
                                </button>
                                <button type="submit" className="ev-btn-primary">
                                    <i className="bx bx-check" /> Create Event
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </FeedLayout>
        </MainLayout>

    );
};

export default CreateEvent;